/**
 * Returns the first index in the array in which the element satisfies the provided testing function.
 * Otherwise -1 is returned if no elements satisfy it.
 * Wraps around array and starts at the given startIndex.
 */
const findIndex = function<T>(
  array: Array<T>,
  testingFn: (item: T, index: number) => boolean,
  startIndex: number = 0,
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  thisArg?: any): number {
  for (let i = startIndex; i < array.length + startIndex; i++) {
    const index = i % array.length;
    if (testingFn.call(thisArg, array[index], index)) {
      return index;
    }
  }
  return -1;
};

export { findIndex };
